import { Controller } from 'react-hook-form';
import { NavLink } from 'react-router-dom';
import { InputText, PermissionEnum, Select, IconChangeLoClock } from '@ui/src';
import { RangeType } from '../../hoc/types';
import { SettingFormTypes } from './types';

import cn from './form.module.css';

const SettingForm = ({
  control,
  errors,
  settingId,
  isEditable,
  riskLevelRangeError,
  activePermissions,
  clearErrors,
}: SettingFormTypes) => (
  <div className={cn.settingForm}>
    <div className={cn.formGroup}>
      <Controller
        control={control}
        name="action"
        defaultValue=""
        render={({ field: { onChange, value } }) => (
          <>
            <Select
              name="action"
              placeholder="Select scenario"
              onChange={onChange}
              value={value}
              title="Scenario"
              selectWrapperClassName={`${cn.scenarioSelect} ${
                errors?.action?.message ? cn.scenarioSelectError : ''
              }`}
              list={[
                {
                  name: 'None',
                  value: RangeType.NONE,
                },
                {
                  name: 'OPS Review',
                  value: RangeType.OPS_REVIEW,
                },
                {
                  name: 'AML Review',
                  value: RangeType.AML_REVIEW,
                },
              ]}
              error={errors?.action?.message}
              disabled={Boolean(!isEditable && settingId)}
              tabIndex={!isEditable && settingId ? -1 : 0}
              fullWidth
            />
            {errors?.action?.message && (
              <div className={cn.error}>{errors?.action?.message}</div>
            )}
          </>
        )}
      />
    </div>
    <Controller
      control={control}
      name="name"
      defaultValue=""
      render={({ field: { onChange, value } }) => (
        <InputText
          name="name"
          placeholder="Enter category name"
          onChange={onChange}
          value={value}
          title="Category name"
          error={errors?.name?.message}
          disabled={Boolean(!isEditable && settingId)}
          tabIndex={!isEditable && settingId ? -1 : 0}
        />
      )}
    />
    <div className={cn.settingFormFlex}>
      <div className={cn.settingScoreInput}>
        <Controller
          control={control}
          name="rangeStart"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <InputText
              name="rangeStart"
              placeholder="Enter risk score from"
              onChange={(e) => {
                onChange(e);

                if (errors?.rangeStart?.message) {
                  clearErrors(['rangeStart']);
                }
              }}
              value={value}
              title="Risk score from"
              error={errors?.rangeStart?.message}
              disabled={Boolean(!isEditable && settingId)}
              tabIndex={!isEditable && settingId ? -1 : 0}
            />
          )}
        />
      </div>
      <div className={cn.settingScoreInput}>
        <Controller
          control={control}
          name="rangeEnd"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <InputText
              name="rangeEnd"
              placeholder="Enter risk score to"
              onChange={(e) => {
                onChange(e);

                if (errors?.rangeEnd?.message) {
                  clearErrors(['rangeEnd']);
                }
              }}
              value={value}
              title="Risk score to"
              error={errors?.rangeEnd?.message}
              disabled={Boolean(!isEditable && settingId)}
              tabIndex={!isEditable && settingId ? -1 : 0}
            />
          )}
        />
      </div>
    </div>
    {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) &&
      settingId && (
        <NavLink
          className={cn.changeLogLink}
          to={`/administration/change-logs?entityType=RISK_SCORE_RANGE&entityId=${settingId}`}
          target="_blank"
        >
          <IconChangeLoClock />
          Change Log
        </NavLink>
      )}
    {riskLevelRangeError && (
      <div className={cn.riskLevelRangeError}>{riskLevelRangeError}</div>
    )}
  </div>
);

export default SettingForm;
